import { SxProps, Theme } from '@mui/system';

const style = {
  textfield: {
    '& .MuiInputBase-root': {
      fontSize: 14,
      fontWeight: 500,
      color: 'grey.800',
      padding: '2px !important',
      verticalAlign: 'center',
      textAlign: 'center',
      marginTop: 0,
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '& .MuiInput-underline:before': {
      borderBottom: 'none',
    },
    '& .MuiInput-underline:after': {
      borderBottom: 'none',
    },
    '& .MuiInputBase-input': {
      textAlign: 'center',
    },
    '& .MuiFilledInput-underline:before': {
      borderBottom: 'none',
    },
    '& .MuiFilledInput-underline:after': {
      borderBottom: 'none',
    },
    '& .MuiFilledInput-underline:hover:not(.Mui-disabled):before': {
      borderBottom: 'none',
    },
    '& .MuiInput-root': {
      '&:before, :after, :hover:not(.Mui-disabled):before': {
        borderBottom: 0,
      },
    },
  },
} satisfies Record<string, SxProps<Theme>>;

export default style;
